import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type BenchmarkRetailMonthValuesFieldsFragment = { __typename?: 'BenchmarkRetailMonthValues', grossSales: number, customerCount: number, grossMarginDollars: number, laborDollars: number, laborHours: number, unitCount?: number | null };

export type BenchmarkRetailMonthFieldsFragment = { __typename?: 'BenchmarkRetailMonth', communityId: string, reportingUnitId: string, periodId: string, status?: Types.BenchmarkSubmissionStatus | null, version?: number | null, submissionId?: string | null, values?: { __typename?: 'BenchmarkRetailMonthValues', grossSales: number, customerCount: number, grossMarginDollars: number, laborDollars: number, laborHours: number, unitCount?: number | null } | null };

export type GetBenchmarkRetailMonthsQueryVariables = Types.Exact<{
  reportingUnitId: Types.Scalars['String']['input'];
  fromPeriodId: Types.Scalars['String']['input'];
  toPeriodId: Types.Scalars['String']['input'];
}>;


export type GetBenchmarkRetailMonthsQuery = { __typename?: 'Query', benchmarkRetailMonths: Array<{ __typename?: 'BenchmarkRetailMonth', communityId: string, reportingUnitId: string, periodId: string, status?: Types.BenchmarkSubmissionStatus | null, version?: number | null, submissionId?: string | null, values?: { __typename?: 'BenchmarkRetailMonthValues', grossSales: number, customerCount: number, grossMarginDollars: number, laborDollars: number, laborHours: number, unitCount?: number | null } | null }> };

export const BenchmarkRetailMonthValuesFieldsFragmentDoc = new TypedDocumentString(`
    fragment BenchmarkRetailMonthValuesFields on BenchmarkRetailMonthValues {
  grossSales
  customerCount
  grossMarginDollars
  laborDollars
  laborHours
  unitCount
}
    `, {"fragmentName":"BenchmarkRetailMonthValuesFields"});
export const BenchmarkRetailMonthFieldsFragmentDoc = new TypedDocumentString(`
    fragment BenchmarkRetailMonthFields on BenchmarkRetailMonth {
  communityId
  reportingUnitId
  periodId
  status
  version
  submissionId
  values {
    ...BenchmarkRetailMonthValuesFields
  }
}
    fragment BenchmarkRetailMonthValuesFields on BenchmarkRetailMonthValues {
  grossSales
  customerCount
  grossMarginDollars
  laborDollars
  laborHours
  unitCount
}`, {"fragmentName":"BenchmarkRetailMonthFields"});
export const GetBenchmarkRetailMonthsDocument = new TypedDocumentString(`
    query GetBenchmarkRetailMonths($reportingUnitId: String!, $fromPeriodId: String!, $toPeriodId: String!) {
  benchmarkRetailMonths(
    reportingUnitId: $reportingUnitId
    fromPeriodId: $fromPeriodId
    toPeriodId: $toPeriodId
  ) {
    ...BenchmarkRetailMonthFields
  }
}
    fragment BenchmarkRetailMonthValuesFields on BenchmarkRetailMonthValues {
  grossSales
  customerCount
  grossMarginDollars
  laborDollars
  laborHours
  unitCount
}
fragment BenchmarkRetailMonthFields on BenchmarkRetailMonth {
  communityId
  reportingUnitId
  periodId
  status
  version
  submissionId
  values {
    ...BenchmarkRetailMonthValuesFields
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetBenchmarkRetailMonths: build.query<GetBenchmarkRetailMonthsQuery, GetBenchmarkRetailMonthsQueryVariables>({
      query: (variables) => ({ document: GetBenchmarkRetailMonthsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetBenchmarkRetailMonthsQuery, useLazyGetBenchmarkRetailMonthsQuery } = injectedRtkApi;
